export interface SecurityOption {
  id: number;
  title: string;
  description: string;
  imageUrl: string | null;
  createdAt: Date;
  updatedAt: Date;
  pricing: OptionPricing;
}

export interface SecurityOptionFull {
  id: number;
  title: string;
  description: string;
  imageUrl: string | null;
  createdAt: Date;
  updatedAt: Date;
  optionPricing: OptionPricing[];
  status: SecurityOptionStatus;
}

export interface OptionPricing {
  id: number;
  unitAmount: number;
  createdAt: Date;
  updatedAt: Date;
  status: OptionPricingStatus;
}

export enum OptionPricingStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum SecurityOptionStatus {
  ACTIVE,
  INACTIVE,
}

export interface CreateProductReq {
  title: string;
  description: string;
  price: number;
  imageUrl?: string;
}

export interface UpdateProductReq {
  title?: string;
  description?: string;
  imageUrl?: string;
}
